import React from 'react'
import './Header.scss'

function Header():JSX.Element {
    return (
        <div className= 'Header'>
           welceome to my Calorie Calculator
        </div>
    )
}

export default Header
